import { gsap } from 'gsap';

export default function initServicesMenu() {
    const wrapper = document.querySelector('[data-services-menu]');
    if (!wrapper) return;

    const panel = wrapper.querySelector('[data-services-menu-panel]');
    const links = [...wrapper.querySelectorAll('[data-services-menu-link]')];
    const toggle = wrapper.querySelector('[data-services-menu-toggle]');
    const iconArrow = wrapper.querySelector('[data-icon-arrow]');
    const iconCross = wrapper.querySelector('[data-icon-cross]');

    const linksReversed = [...links].reverse();
    let tl = null;
    let isOpen = false;
    let isMobile = window.matchMedia('(max-width: 767px)').matches;

    // Track breakpoint changes
    window.matchMedia('(max-width: 767px)').addEventListener('change', (e) => {
        if (isOpen) close();
        isMobile = e.matches;
    });

    function buildTimeline() {
        if (tl) tl.kill();

        const isUp = isMobile;
        const staggerLinks = isUp ? linksReversed : links;

        links.forEach((link, i) => {
            const z = isUp ? i + 1 : links.length - i;
            gsap.set(link, { position: 'relative', zIndex: z });
        });

        gsap.set(panel, {
            clipPath: isUp ? 'inset(100% 0% 0% 0%)' : 'inset(0% 0% 100% 0%)',
        });
        gsap.set(links, { yPercent: isUp ? 80 : -80 });
        gsap.set(iconCross, { autoAlpha: 0, rotate: -45 });
        gsap.set(iconArrow, { autoAlpha: 1, rotate: 0 });

        tl = gsap.timeline({
            paused: true,
            defaults: { ease: 'power3.out' },
        });

        tl
        .to(panel, {
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: 0.4,
            ease: 'power3.inOut',
        })
        .to(staggerLinks, {
            yPercent: 0,
            duration: 0.5,
            stagger: 0.06,
            ease: 'power3.out',
        }, 0.1)
        .to(iconArrow, {
            autoAlpha: 0,
            rotate: 45,
            duration: 0.2,
            ease: 'power2.in',
        }, 0)
        .to(iconCross, {
            autoAlpha: 1,
            rotate: 0,
            duration: 0.2,
            ease: 'power2.out',
        }, 0.15);
    }

    // Build initial timeline
    buildTimeline();

    function open() {
        if (isOpen) return;
        buildTimeline();
        tl.play();
        isOpen = true;
        document.addEventListener('click', onOutsideClick);
        document.addEventListener('keydown', onEsc);
    }

    function close() {
        if (!isOpen) return;
        tl.reverse();
        isOpen = false;
        document.removeEventListener('click', onOutsideClick);
        document.removeEventListener('keydown', onEsc);
    }

    function onOutsideClick(e) {
        if (!wrapper.contains(e.target)) {
            close();
        }
    }

    function onEsc(e) {
        if (e.key === 'Escape') {
            close();
        }
    }

    toggle.addEventListener('click', () => {
        isOpen ? close() : open();
    });
}